var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.notification.color,"multi-line":"","top":"","timeout":6000,"dark":""},model:{value:(_vm.notification.show),callback:function ($$v) {_vm.$set(_vm.notification, "show", $$v)},expression:"notification.show"}},[_vm._v("\n  "+_vm._s(_vm.notification.message)+"\n  "),_c('v-btn',{attrs:{"color":"white","outlined":""},on:{"click":_vm.hideNotification}},[_vm._v("\n    Cerrar\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Notification.vue?vue&type=template&id=1f10adf4
// module id = null
// module chunks = 